import { MarkDef } from '@src/types/Mark';

export function markEqual<T>(markA: MarkDef<T>, markB: MarkDef<T>) {
  return markA.text === markB.text && markA.type === markB.type;
}
